import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";

export const ConceptWrapper = styled.div.attrs(({ bgColor, theme }) => ({
	bg: bgColor ? `#${bgColor}` : theme.colors.white,
}))`
	background-color: ${({ theme, bgColor }) => (bgColor ? `#${bgColor}` : theme.colors.white)};
	position: relative;
	padding: 0 3rem;

	${media.lessThan(breakpoints.ipad)`
  		padding: 1rem 1rem;
  	`}

	${media.lessThan(breakpoints.mobile)`
	&:after {
		content: "";
		width: ${({ notFirstSlide }) => (notFirstSlide ? "10%" : "")};
		height: 100%;
		background: ${({ bg }) => `linear-gradient(to left, rgb(255 255 255 / 0%) 0%, ${bg})`};
		display: block;
		position: absolute;
		top: 0;
		left: 0;
		/* z-index: 1; */
	}
  		padding: 0;
  	`}
	  &:before {
		content: "";
		width: ${({ notFirstSlide }) => (!notFirstSlide ? "17%" : "10%")};
		height: 100%;
		background: ${({ bg }) => `linear-gradient(to right, rgb(255 255 255 / 0%) 0%, ${bg})`};
		display: block;
		position: absolute;
		top: 0;
		right: 0;
		z-index: 1;
	}

	${media.greaterThan(breakpoints.mobile)`
        &:before {
            content: none;
        }
    `}
`;

export const ConceptInnerWrapper = styled.div`
	max-width: ${({ theme }) => theme.grid.outer};
	padding: 3rem 0 3rem 1rem;
	width: auto;

	${media.greaterThan(breakpoints.mobile)`
        margin: 0 auto;
        padding: 3rem 1rem;
        width: auto;
    `}
`;
